import { resolveOwnReferralCode } from '@/entities/referral/lib/resolveOwnReferralCode'

export function mapPersonalReferral(raw) {
  if (!raw || typeof raw !== 'object') {
    return { refCode: null, balance: 0 }
  }

  return {
    refCode: resolveOwnReferralCode(raw),
    balance: Number(raw.balance ?? 0) || 0,
  }
}
